import React, { Component } from 'react';
import { lenders } from '../helpers/Lists.js';

interface IProps {
    label?: any;
    selectedlender?: string;
    classes?: string;
    onChange(v: any): void;
    onBlur?(): void;
}

export class LenderSelect extends Component<IProps, any> {
    render() {
        return (
            <div className='grid justify-c'>
                {this.props.label &&
                <label htmlFor='lenders'>{this.props.label}</label>
                }
                <select name="lenders" id="lenders" aria-required="true" aria-invalid="false" 
                    className={this.props.classes ?? ''}
                    onChange={this.props.onChange}
                    onBlur={() => {if (this.props.onBlur) this.props.onBlur();}}>
                    <option key={'currentlendertopup-select'}  value="" selected={!this.props.selectedlender} className="placeholder">Select</option>
                    {lenders.map((l) => {
                        return <option key={'currentlendertopup-'+l.value} value={l.value} selected={l.value === this.props.selectedlender}>{l.name}</option>
                    })
                    }
                </select>
            </div>
        );
    }
}
